// src\services\DeviceDataService.js
import http from '../http-image-common';

class DeviceDataService {
  getAll() {
    return http.get("/media");
  }

  getAllDevices() {
    return http.get(`/user-device-list`);
  }

  getAllUserDevices(user_id) {
    return http.get(`/user-device-list?user_id=${user_id}`);
  }

  get(id) {
    return http.get(`/media/edit/${id}`);
  }

  create(data) {
    return http.post("/media/add", data);
  }

  update(id, data) {
    return http.put(`/media/update/${id}`, data);
  }

  delete(id) {
    return http.put(`/media/delete/${id}`);
  }
}

export default new DeviceDataService();
